export default __webpack_public_path__ + "static/media/gain.88c5cafe.svg";